export default {"src":"/_next/static/media/ethereum.ad6c4c10.svg","height":2500,"width":1535};